import { render, staticRenderFns } from "./ReportPmtaRelayIndicators.vue?vue&type=template&id=24e6116a&scoped=true"
import script from "./ReportPmtaRelayIndicators.vue?vue&type=script&lang=js"
export * from "./ReportPmtaRelayIndicators.vue?vue&type=script&lang=js"
import style0 from "./ReportPmtaRelayIndicators.vue?vue&type=style&index=0&id=24e6116a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e6116a",
  null
  
)

export default component.exports